import api from '@/utils/api'
import { constructFilter } from '@/utils/servicesUtil'

export default {
    getAllViberCampaigns(page, perPage, field, order) {
        const sort = (field && order) ? [field, order] : []
        const query = page && perPage && `sort=${JSON.stringify(sort)}&` +
            `range=${JSON.stringify([page - 1, perPage])}`
        return api.get(`recurring-viber-campaigns${query ? `?${encodeURI(query)}` : ''}`)
    },
    getViberCampaignById(id) {
        return api.get(`recurring-viber-campaigns/${id}`)
    },
    duplicateViberRecurringCampaign(id) {
        return api.post(`recurring-viber-campaigns/${id}/duplicate`)
    },
    getMessages(id, filters) {
        return api.get(`recurring-viber-campaigns/${id}/messages${constructFilter(filters)}`)
    },
    getFallbacks(id, filters) {
        return api.get(`recurring-viber-campaigns/${id}/fallbacks${constructFilter(filters)}`)
    },
    createViberCampaign(campaign) {
        return api.post('recurring-viber-campaigns', campaign)
    },
    updateViberCampaign(campaign) {
        return api.put(`recurring-viber-campaigns/${campaign.id}`, campaign)
    },
    deleteViberCampaign(id) {
        return api.delete(`recurring-viber-campaigns/${id}`)
    },
    updateViberCampaignStatus(id, status) {
        return api.put(`recurring-viber-campaigns/${id}/pause/${status}`)
    }
}
